import React, { useState, useEffect } from "react";
import { DateTime } from "luxon";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import { TextInput } from "@common/textInput";
import { DateTimeInput } from "@common/dateTimeInput";
import { TrashIcon } from "@common/trashIcon";
import { holiday as h } from "@planzone/dto";
import { Props } from "./types";
import styles from "./styles.scss";

function Holiday({ holiday = h, onChange, onRemove }: Props) {
  const { t } = useTranslation();
  const userTimezone = DateTime.local().zoneName;
  const [name, setName] = useState(holiday.name);
  const [day, setDay] = useState<string>(holiday.day);
  const [holidayDate, setHolidayDate] = useState<string>(holiday.holidayDate);
  const handleDateChange = (newDate: string) => {
    const dt = DateTime.fromISO(newDate, { zone: "utc" }).setZone(userTimezone);
    if (!dt.isValid) return;
    setDay(dt.toUTC().toISO() ?? "");
    setHolidayDate(dt.toFormat("yyyy-MM-dd"));
  };

  useEffect(() => {
    onChange({ ...holiday, name, day, holidayDate });
  }, [name, day, holidayDate]);

  return (
    <div className={styles.holidayForm}>
      <div className={styles.holidayRow}>
        <TextInput
          placeholder={t(
            "calendarHolidays.creation.holidayCreation.namePlaceholder",
          )}
          value={name}
          input={setName}
          className={styles.holidayNameInput}
        />
        <DateTimeInput
          dateTime={
            holidayDate
              ? (DateTime.fromISO(holidayDate, { zone: userTimezone })
                  .toUTC()
                  .toISO() ?? "")
              : ""
          }
          placeholder={t(
            "calendarHolidays.creation.holidayCreation.datePlaceholder",
          )}
          input={handleDateChange}
        />
        <button
          type="button"
          className={styles.removeButton}
          onClick={onRemove}
        >
          <TrashIcon className={classNames(styles.icon, styles.removeIcon)} />
        </button>
      </div>
    </div>
  );
}

export { Holiday };
